/**
 * scrollTop that parks the moving progress head at a fixed viewport anchor
 * line while the page follows the catch-up sprint, clamped to the document's
 * scrollable range.
 */
export function getCatchupScrollTop(input: {
  /** The head's center in document-space px. */
  headDocumentY: number
  viewportHeight: number
  /** Full document scroll height. */
  scrollHeight: number
  /** Fraction of the viewport height the head should sit at (0 = top). */
  anchorRatio: number
}): number {
  const { headDocumentY, viewportHeight, scrollHeight, anchorRatio } = input
  const target = headDocumentY - viewportHeight * anchorRatio
  const maxScroll = Math.max(0, scrollHeight - viewportHeight)
  return Math.min(Math.max(target, 0), maxScroll)
}
